import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "pgs_cookie_consent";

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(KEY);
    if (!stored) {
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed z-50 bottom-[76px] lg:bottom-5 left-4 right-4 lg:left-auto lg:right-6 lg:max-w-md"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          role="dialog"
          aria-label="Cookie notice"
          data-testid="cookie-consent"
        >
          <div className="bg-white border border-[#D9E0E4] rounded-lg shadow-xl p-5">
            <div className="flex items-start gap-3">
              <div className="h-9 w-9 rounded-md bg-[#EAF1F4] flex items-center justify-center shrink-0">
                <Cookie className="h-5 w-5 text-teal" />
              </div>
              <div>
                <p className="text-[14px] text-navy font-medium mb-1">We use cookies</p>
                <p className="text-[13px] text-muted-foreground leading-relaxed">
                  We use essential cookies to run this site and optional analytics to improve it.
                  See our <Link to="/cookie-notice" className="text-teal underline underline-offset-2">Cookie Notice</Link>.
                </p>
              </div>
            </div>
            <div className="mt-4 flex gap-2">
              <button
                onClick={() => decide("accepted")}
                className="flex-1 min-h-[42px] rounded-md bg-teal text-white text-[14px] font-semibold hover:bg-[#075652] transition-colors"
                data-testid="cookie-accept"
              >
                Accept
              </button>
              <button
                onClick={() => decide("declined")}
                className="flex-1 min-h-[42px] rounded-md border border-[#D9E0E4] text-navy text-[14px] font-semibold hover:bg-[#EAF1F4] transition-colors"
                data-testid="cookie-decline"
              >
                Decline
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
